import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background-50/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="text-2xl md:text-3xl font-heading text-primary-500 whitespace-nowrap">韩漫</span>
            <span className="hidden sm:block text-sm text-foreground-600 whitespace-nowrap">漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link to="/" className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${location.pathname === '/' ? 'text-primary-500 bg-primary-50' : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'}`}>
              首页
            </Link>
            <Link to="/category/all" className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${location.pathname.startsWith('/category') ? 'text-primary-500 bg-primary-50' : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'}`}>
              分类浏览
            </Link>
            <Link to="/about" className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${location.pathname === '/about' ? 'text-primary-500 bg-primary-50' : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'}`}>
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 px-4 py-2 text-sm rounded-full border border-background-200 bg-background-50 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 space-y-1">
            <Link to="/" className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
            <Link to="/category/all" className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer">分类浏览</Link>
            <Link to="/about" className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link>
            <div className="px-4 py-2">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-full px-4 py-2 text-sm rounded-full border border-background-200 bg-background-50 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                />
                <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}